/**
 @author hjj
 @date 2020/6/4 7:53 下午
 */

import store from '@/store';
import Vue from 'vue'
import {comLegend, comColor,openInfoWin,closeInfoWin} from "../../script/comChart";
import {getOption} from '@/assets/axios/mapAxio'
import {clickDown,renderEvent} from "../../script/comMap"
import jsonVal from "./json/data.json";
let vm = new Vue();
let vuex = store.state;
export default {
    //类型
    type: '3D地球',
    //类别
    class: 'chart',
    //组件名称
    name: '3D地球',
    //排序
    sort: 14,
    //是否在多维分析展示
    viewType:true,
    //图标
    iconImg: '/img/3Dearth.png',
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 0,
        //最小度量数量
        minDLLength: 1,
        //最大维度数量
        maxWDLength: 2,
        //最大度量数量
        maxDLLength: 2,
        //高
        dp_height: 200,
        //宽
        dp_wight: 300,
        //最小高
        dp_min_height: 50,
        //最小宽
        dp_min_wight: 50,
        //是否展示维度配置
        isWdConfig: true,
        //是否展示度量配置
        isDlConfig: true,
        //是否展示JSON配置
        isJSONConfig: true,
        //是否展示公共配置
        isComConfig: true,
        //是否展示边框
        isComBorder: true,
    },
      // 子集展示的配置项
    chilCharts: [
        {
            name: 'charts',
            ordImg: '/img/3Dearth.png',
            bigImg:  '/img/3Dearth.png',
            //默认配置
            chartParam: {
            },
            wdParam: {},
            dlParam: {
                stack: ''
            },
            //提示
            viewDpPrompt: '维度按拖拽顺序，第一个是经度，第二个是纬度',
        }
    ],
    //维度组件
    wdComponent: null,
    //维度配置参数
    wdHandle(option) {
        return {}
    },
    //度量组件
    dlComponent: null,
     //度量参数
    dlHandle(option) {
        return {
            //堆叠
            stack: '',
            //颜色
            color: '',
            //自定义
            customColor: false,
            //数值
            label: {
                show: false,
            },
            //主次轴
            lTAxis: 0,
        }
    },
    //右侧图表配置参数
    params(option) {
        return {
            //图例配置
            legend: {
                show: true,
                position: 'top',
                //字体
                font: {
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                    size: 14,
                },
                 //间隔
                marInterval:10,
            },
            map:{
                label: {
                    show: false ,
                    color: "#fff" ,
                    fontSize: 12 ,
                    backgroundColor: 'rgba(0,23,11,0)'
                },
                zoom:1,
                mapinfo:{},
                name:'全国',
                id:100000,
                color:'rgb(5,101,123)',
                itemStyle:{
                    borderColor: "rgb(62,215,213)", //省市边界线
                    areaColor:'rgb(5,101,123)',
                    shadowColor: 'rgba(166, 230, 236, 0.6)',
                    shadowOffsetX: 0,
                    shadowOffsetY: 0,
                    shadowBlur: 10
                },
                mapStyle:'darkblue',
                emphasis:{
                    itemStyle:{
                        areaColor:'#ccc'
                    }
                },
                amapMap:{
                    zoom: 5.5,
                    center: '110,33', //中心点
                }
            },
            visualMap: {
                show: true,
                type: 'piecewise' ,
                splitNumber:5,
                min: 0,
                max: 1000,
                top: 0,
                right:  0,
                left:0,
                bottom: 0,
                showLabel:true,
                textStyle: {
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                },
                showtext:true,
                inverse:false,
                inRange:{
                    color: ['#5b9fbf', '#5bbfa2', '#5bbf67', '#7abf5b', '#a6bf5b', '#bfab5b', '#e1aa52', '#d3a589', '#d69085', '#d98d8d']
                },
                showpieces:false,
                pieces:[]
            },
            tooltip:{
                show: true ,
                backgroundColor: 'rgba(50,50,50,0.7)' ,
                borderColor: '' ,
                borderWidth: 0 ,
                padding: 5 ,
                textStyle: {
                    color: '#fff' ,
                    fontSize: 14 ,
                }
            },
        }
    },
    //右侧图表配置组件列表
    configModule: [
        // {
        //     name: '地图配置',
        //     component: () => import('../../comConfig/comMap/comMap.vue')
        // },
        // {
        //     name: '视觉映射配置',
        //     component: () => import('../../comConfig/comvisualMap/comvisualMap.vue')
        // },
        // {
        //     name: '弹板配置',
        //     component: () => import('../../comConfig/comTooltip/comTooltip.vue')
        // },
    ],
    //接口
    JSONData: {
        //静态数组
        listDaVal: jsonVal,
        //接口参数
        params: {
            //维度
            wd: ['维度1','维度2'],
            //度量
            dl: ['度量1','度量2']
        },
        //引用的组件
        jsonPonent: () => import('./json/json'),
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {
        try {
            let setChart = chart.setting;
            let params = nowChart.comParam.JSONData.params;
            let dl = params.dl;
            let wd = params.wd;
            let dlStyParam = setChart.dlStyParam;
            let wdStyParam = setChart.wdStyParam;
            let head = {
                listWD: [],
                listZB: []
            };
            let dt = JSON.parse(json);
            wd.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.wdList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listWD.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comWDConfig)),
                        params: JSON.parse(JSON.stringify(wdStyParam[index] || nowChart.comPonent.wdParams))
                    };
                    data.config.alias = item;
                    setChart.wdList.push(data)
                }
            });
            dl.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.dlList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listZB.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comDLConfig)),
                        params: JSON.parse(JSON.stringify(dlStyParam[index] || nowChart.comPonent.dlParams))
                    };
                    data.config.alias = item;
                    setChart.dlList.push(data)
                }
            });
            let JkData = {
                dataTabel: {
                    dt: dt,
                    head: head
                },
                totalCount: dt.length
            };
            chart.data = JkData;
        } catch (e) {
            chart.data = {};
        }
    },
    //图表渲染之前
    renderBefore(chart, nowChart,dom) {
        let echart = echarts.init(dom);
        echart.dispose()
        echart = null;
        nowChart.comConfig.gridType = null;
    },
    //图表渲染
     rendering(chart, nowChart, dom) {
        let dataAll = JSON.parse(JSON.stringify(chart.data.dataTabel));
        //度量维度配置
        let config = chart.setting;
        // 图表轴
        let comConfig = nowChart.comConfig;
        let echart = echarts.init(dom);
        //右侧图表配置参数
        let params = config.params;
        // 维度配置参数
        let wdParams = config.wdList;
        // 度量配置参数
        let dlParams = config.dlList;
        //维度名称
        let wd = dataAll.head.listWD;
        //度量
        let dl = dataAll.head.listZB;
        //颜色
        let colorList = JSON.parse(JSON.stringify(comColor(comConfig.colorIndex)));
        //所有的维度数据
        let dataVal = dataAll.dt;
        //更改维度数据格式
        dataVal.map((item, index) => {
            let da = {};
            for (let i in item) {
                da[i.toLowerCase()] = item[i];
            }
            dataVal[index] = da;
        });
        //限制数据长度
        let legendList = [];
        if (dataAll.dt.length > comConfig.valLength) {
            dataAll.dt.length = nowChart.comConfig.valLength;
        }
        //获取度量数据
        let dlVal = [];
        dl.map((i, index) => {
            let configDL = {};
            dlParams.map((c) => {
                if (c.name === i.filed) {
                    configDL = c;
                }
            });
            let node = {
                value: [],
                filedNmae: i.filed,
                aliasNmae: i.alias,
                config: configDL,
            };
            node.value = dataVal.map((item) => {
                if (configDL.params.customColor) {
                    colorList[index] = configDL.params.color;
                    return {
                        value: item[i.alias],
                        itemStyle: {
                            color: configDL.params.color
                        }
                    } || 0
                } else {
                    return item[i.alias] || 0
                }
            });
            dlVal.push(node);
            legendList.push(i.alias);
        });
        //获取维度数据
        let wdVal = [];
        // dataVal.map((item,idx) => {
        //    wdVal.push([item[wd[0].alias],item[wd[1].alias]]);
        // });
        //地球开始
        // 使用 echarts 绘制世界地图的实例作为纹理
        let canvas = document.createElement('canvas');
        let mapChart = echarts.init(canvas, null, {
            width: 1096,
            height: 298
        });
        let pOp = {
            // 两种方法绘制地图都可以
            geo: {
                map: 'world',
                label:{
                    emphasis: {
                        color:'#000',
                        fontSize: 12
                    }
                },
                itemStyle: {
                    areaColor: 'transparent',
                    borderColor: 'transparent',
                    // areaColor: 'pink',
                    // borderColor: 'red'
                },
                emphasis:{
                    itemStyle:{
                        areaColor: '#EE7621'
                    }
                },
                top: 0, left: 0,
                right: 0, bottom: 0,
                boundingCoords: [[-180, 90], [180, -90]]//定义定位的左上角以及右下角分别所对应的经纬度
            },
        }
        mapChart.setOption(pOp);
        let option = {
            // legend: {
            //     orient: 'vertical',
            //     bottom: 40,
            //     left: 25,
            //     data:['IP定位1','IP定位2'],
            //     itemWidth:30,
            //     itemHeight:10,
            //     itemGap:30,
            //     textStyle: {
            //         fontSize:16,
            //         color: '#03cecb'
            //     },
            // },
            tooltip: {
                show: true,
                backgroundColor: 'rgba(15,79,140,0.5)',
                borderColor: '#2898bf',
                borderWidth: 1,
                padding:10,
                formatter (d) {
                    // console.log(d)
                    var ip=d.data.ip;
                    var jw=d.value
                    return 'ip地址：' + ip+'</br>所在国家: ' + d.name + '</br>经纬度: ' + jw
                }
            },
            globe: {
                baseTexture: './image/world2.png',
                heightTexture:'./image/world1.jpg',
                displacementScale: 0.04,
                shading: 'lambert',
                // environment: '#03051a',
                light: { // 光照阴影
                    main: {
                        color: '#fff', // 光照颜色
                        intensity: 1.2, // 光照强度
                        shadowQuality: 'high', //阴影亮度
                        shadow: true, // 是否显示阴影
                        alpha: 40,
                        beta: -30
                    },
                    ambient: {
                        intensity: 0.5
                    }
                },
                // viewControl: {
                //     alpha: 30,
                //     beta: 160,
                //     targetCoord: [116.46, 39.92],
                //     // center:["50%","50%",'0'],
                //     autoRotate: true,
                //     autoRotateAfterStill: 10,
                //     distance: 150,
                // },
                viewControl:{
                    projection: 'perspective' ,
                    distance: 100 ,
                    alpha: 40 ,
                    beta: 0 ,
                    autoRotate: true ,
                    autoRotateDirection:'cw' ,
                    autoRotateSpeed: 10,
                    targetCoord: [0, 0],
                    autoRotateAfterStill: 3 ,
                },
                layers: [{
                    type: 'blend',
                    texture: mapChart
                }]
            },
            series: [
                {
                    name:'IP定位1',
                    type: 'scatter3D',
                    coordinateSystem: 'globe',
                    symbol:'pin',
                    symbolSize: 20,
                    itemStyle: {
                        color:'#0399f5',
                        borderWidth: 1,
                        borderColor:'#02f2fd'
                    },
                    emphasis: {
                        label:{
                            show: false
                        },
                        itemStyle: {
                            color:'#EE7621',
                        }
                    },
                    data: [],
                    animation: true
                }, {
                    name:'IP定位2',
                    type: 'scatter3D',
                    coordinateSystem: 'globe',
                    symbol:'pin',
                    symbolSize: 40,
                    label: {
                        show: false,
                    },
                    itemStyle: {
                        color:'#EE7621',
                        opacity:1
                    },
                    data:[]
                }
            ]
        }
        echart.clear();
        echart.setOption(option);
    }
}


